import type { StoreTagDTO } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export const createStoreTag = async ({ label }: { label: string }) => {
  const response = await gozokiApiWithAuth.post<{ tag: StoreTagDTO }>('/store-tags', { label })
  return response.data.tag
}
